import { useNavigate } from 'react-router-dom';
import { useRoutePrefix } from '@Hooks/index';
import { MenuItemRouteName } from '@Components/enum';
import BaseNameSideItem from '@Enum/BaseNameSideMenuItem.enum';

import MRFeatureRoutePath from '@Features/router/mr/MRFeatureRoutePath.enum';
import ESSFeatureRoutePath from '@Features/router/ess/ESSFeatureRoutePath.enum';
import { resolveMyRequestsPath } from '../utils/resolveMyRequestsPath';

interface ReturnValue {
  menuItemNavigate: (menuItemKey: string) => void;
}

const useMenuItemNavigator = (): ReturnValue => {
  const navigate = useNavigate();
  const routePrefix = useRoutePrefix();

  const menuItemNavigate = (menuItemKey: string): void => {
    if (
      menuItemKey === BaseNameSideItem.HOME ||
      menuItemKey === BaseNameSideItem.DASHBOARD
    ) {
      navigate('/');
      return;
    }

    if (menuItemKey === BaseNameSideItem.ESS) {
      navigate(
        `/ess/${ESSFeatureRoutePath.MANAGE_REQUESTS}/${ESSFeatureRoutePath.MANAGE_REQUEST_LEAVE_REQUEST}`
      );
      return;
    }

    if (menuItemKey === BaseNameSideItem.MR) {
      navigate(
        `/mr/${MRFeatureRoutePath.MANAGE_REQUESTS}/${MRFeatureRoutePath.MANAGE_REQUEST_MATERIAL_REQUEST}`
      );
      return;
    }

    if (menuItemKey === BaseNameSideItem.MY_REQUESTS) {
      const lastSegmentPath = resolveMyRequestsPath(routePrefix);
      navigate(
        `/${routePrefix}/${MenuItemRouteName[menuItemKey]}/${lastSegmentPath}`
      );
    } else {
      navigate(`/${routePrefix}/${MenuItemRouteName[menuItemKey]}`);
    }

    if (menuItemKey === BaseNameSideItem.PROCUREMENT) {
      navigate(
        `/mr/${MRFeatureRoutePath.PROCUREMENT}/${MRFeatureRoutePath.PROCUREMENT_PURCHASE_REQUEST}`
      );
    }
  };

  return { menuItemNavigate };
};

export default useMenuItemNavigator;
